/* DeSiM 公式店 — 骨格レベルの最小限 JS。SP ハンバーガー ⇄ ドロワーの開閉だけ。
   後続タスクがページ固有の JS を足すときは別ファイルにする（このファイルは
   layout/theme.liquid から常時読み込まれる共通スクリプト）。 */
(function () {
  var toggle = document.querySelector('[data-ds-drawer-toggle]');
  var drawer = document.querySelector('[data-ds-drawer]');
  if (!toggle || !drawer) return;

  toggle.addEventListener('click', function () {
    var isOpen = drawer.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });
})();
